import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of } from 'rxjs';
import { Event } from '../../models/types';
import { environment } from '../../environments/environment.development';
import { LoginService } from './login.service';
import { AddEventComponent } from '../components/add-event/add-event.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  private modalRef: NgbModalRef | null = null;

  constructor(private http: HttpClient
    , private loginService: LoginService,
    private modalService: NgbModal
  ) { }

  getAllEvents(): Observable<any> {
    return this.http.get<any>(environment.eventURL);
  }

  getEventsByFarmId(farmId: number): Observable<any> {
    return this.http.get<any>(`${environment.eventURL}/farm/${farmId}`);
  }

  addEvent(event: Event): Observable<any> {
    if (this.loginService.IsUserLoggedIn() && this.loginService.IsValidToken()) {
      return this.http.post<Event>(environment.eventURL, event);
    } else {
      console.log("You must be logged in to add an event");
      // Return an observable that emits an empty event
      return of({} as Event);
    }
  }

  updateEvent(event: Event): Observable<Event> {
    if (this.loginService.IsUserLoggedIn() && this.loginService.IsValidToken()) {
      return this.http.put<Event>(`${environment.eventURL}/${event.eventID}`, event);
    } else {
      return of({} as Event);
    }
  }

  deleteEvent(id: string): Observable<any> {
    if (this.loginService.IsUserLoggedIn() && this.loginService.IsValidToken()) {
      console.log("Deleting event with ID:", id);
      return this.http.delete<any>(`${environment.eventURL}/${id}`, {
        headers: {
          'authorization': this.loginService.GetToken()!
        }
      }).pipe(
        catchError((error) => {
          console.error('Error deleting event:', error);
          return of({ message: 'Error deleting event' });
        })
      );
    } else {
      console.log("You must be logged in to delete an event");
      return of({ message: 'You must be logged in to delete an event' });
    }
  }

  uploadEventImage(eventID: number, image: File, orgAdmin: boolean): Observable<any> {
    const formData = new FormData();
    formData.append('image', image);

    const isAdmin = this.loginService.IsValidAdminToken();

    if (isAdmin || orgAdmin) {
      return this.http.post(`${environment.eventURL}/${eventID}/images`, formData, {
        headers: {
          ...(this.loginService.IsValidToken() && { 'authorization': this.loginService.GetToken()! })
        },
        observe: 'response',
      });
    } else {
      console.log("You must be an admin or org admin to upload an event image");
      return of(null);
    }
  }

  updateEventImage(eventID: number, image: File, orgAdmin: boolean): Observable<any> {
    const formData = new FormData();
    formData.append('image', image);

    const isAdmin = this.loginService.IsValidAdminToken();

    if (isAdmin || orgAdmin) {
      return this.http.put(`${environment.eventURL}/${eventID}/images`, formData, {
        headers: {
          ...(this.loginService.IsValidToken() && { 'authorization': this.loginService.GetToken()! })
        },
        observe: 'response',
      });
    } else {
      console.log("You must be an admin or org admin to upload an event image");
      return of(null);
    }
  }

  toggleExposeEvent(eventID: number) {
    return this.http.put(`${environment.eventExposeURL}/${eventID}`, {
      headers: {
        ...(this.loginService.IsValidToken() && { 'authorization': this.loginService.GetToken()! })
      },
      observe: 'response',
    });
  }
}
